/**
 * Valores iniciais do formulário de Member.
 */
export const initialMemberValues = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    document: "", // CPF
    birthDate: null,
    gender: "",
    maritalStatus: "single",
    photoUrl: null,

    // Responsável (pai/mãe/responsável pelo contato). Mesmo campo que a IA do
    // WhatsApp grava (responsibleName) — unifica painel e bot.
    responsibleName: "",

    // Endereço
    zipCode: "",
    address: "",
    number: "",
    complement: "",
    neighborhood: "",
    city: "",
    state: "",
    country: "Brasil",

    // Emergência
    emergencyContact: {
        name: "",
        phone: "",
        email: "",
        relationship: ""
    },

    // Saúde
    healthInfo: {
        bloodType: "",
        allergies: "",
        medications: "",
        medicalConditions: "",
        observations: ""
    },

    status: "lead",
    xpTotal: 0,
    consultant: null,
    teacher: null,
};
